import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const refresh = useCallback(async () => {
    if (!getToken()) return setMe(false);
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("tro_me", JSON.stringify(data));
      setMe(data);
    } catch (err) {
      const cached = !err.response && JSON.parse(localStorage.getItem("tro_me") || "null");
      if (cached) return setMe(cached);
      setToken(null);
      localStorage.removeItem("tro_me");
      setMe(false);
    }
  }, []);
  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setMe(false);
      return;
    }
    refresh();
  }, [refresh]);
  const signIn = async (token) => {
    setToken(token);
    await refresh();
  };
  const signOut = () => {
    setToken(null);
    localStorage.removeItem("tro_me");
    setMe(false);
  };
  return <AuthCtx.Provider value={{ me, refresh, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
